import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 查询账单列表
 * @param {Object} data
 * @returns
 */
export function listDebt (data) {
  return request.post('/ooh-invest/v1/debt/listDebt', qs.stringify(data))
}

/**
 * 查询对账单明细
 * @param {Object} data
 * @returns
 */
export function listDebtDetail (data) {
  return request.post('/ooh-invest/v1/debt/listDebtDetail', qs.stringify(data))
}

/**
 * 查询单个账单
 * @param {Object} data
 * @returns
 */
export function getDebt (data) {
  return request.post('/ooh-invest/v1/debt/getDebt', qs.stringify(data))
}

/**
 * 调整账单明细的金额
 * @param {Object} data
 * @returns
 */
export function updateDebtDetailAmount (data) {
  return request.post('/ooh-invest/v1/debt/updateDebtDetailAmount', qs.stringify(data))
}

/**
 * 确认对账单明细
 * @param {Object} data
 * @returns
 */
export function confirmDebtDetail (data) {
  return request.post('/ooh-invest/v1/debt/confirmDebtDetail', qs.stringify(data))
}

/**
 * 统计账单-按合同分租
 * @param {Object} data
 * @returns
 */
export function countAmountGbContract (data) {
  return request.post('/ooh-invest/v1/debt/countAmountGbContract', qs.stringify(data))
}

/**
 * 查询账单列表-通过合同主键
 * @param {Object} data
 * @returns
 */
export function listDetailByContract (data) {
  return request.post('/ooh-invest/v1/debt/listDetailByContract', qs.stringify(data))
}

/**
 * 创建结算单
 * @param {Object} data
 * @returns
 */
export function createDebt (data) {
  return request.post('/ooh-invest/v1/debt/createDebt', qs.stringify(data))
}
/**
 * 删除结算单
 * @param {Object} data
 * @returns
 */
export function delDebt (data) {
  return request.post('/ooh-invest/v1/debt/delDebt', qs.stringify(data))
}
/**
 * 查询账单列表-通过结算单主键
 * @param {Object} data
 * @returns
 */
export function listDetailByDebt (data) {
  return request.post('/ooh-invest/v1/debt/listDetailByDebt', qs.stringify(data))
}
/**
 * 完结结算单
 * @param {Object} data
 * @returns
 */
export function finishDebt (data) {
  return request.post('/ooh-invest/v1/debt/finishDebt', qs.stringify(data))
}
/**
 * 设置结算单调差项
 * @param {Object} data
 * @returns
 */
export function adjustDebtAmount (data) {
  return request.post('/ooh-invest/v1/debt/adjustDebtAmount', qs.stringify(data))
}
/**
 * 添加对账单明细
 * @param {Object} data
 * @returns
 */
export function addDebtDetail (data) {
  return request.post('/ooh-invest/v1/debt/addDebtDetail', qs.stringify(data))
}
/**
 * 删除对账单明细
 * @param {Object} data
 * @returns
 */
export function delDebtDetail (data) {
  return request.post('/ooh-invest/v1/debt/delDebtDetail', qs.stringify(data))
}
/**
 * 创建合同的账单明细
 * @param {Object} data
 * @returns
 */
export function createDebtDetail (data) {
  return request.post('/ooh-invest/v1/debt/createDebtDetail', qs.stringify(data))
}
// 统计账单-按线路和费用类型
export function countAmountGbAsset (params) {
  return request.get('/ooh-invest/v1/debt/countAmountGbAsset', { params })
}
// 统计合同已结算的费用的时间区间
export function countDebtDurDate (params) {
  return request.get('/ooh-invest/v1/debt/countDebtDurDate', { params })
}
